// extracted by mini-css-extract-plugin
export var footer = "_rt-0";
export var inherit = "_rt-1";
export var input = "_rt-2";
export var modalContent = "_rt-3";
export var quillEditor = "_rt-4";
export var subtitle = "_rt-5";